import TrainingAttendance from '../attendance';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingAttendance.store((data, fetch) => {
    const { trainingId, sessionId, lessonId } = data;
    
    // Prepare request
    let formData = new FormData();
    ['lesson_status']
        .map(key => data[key] !== undefined ? formData.append(key, data[key]) : null);
    
    return fetch.post(`/trainings/${trainingId}/sessions/${sessionId}/lessons/${lessonId}/attendances`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
